const STORAGE_KEY = "confidacare_auth";
const SESSION_TOKEN_KEY = "confidacare_auth_access_token";

type StoredAuth = {
  token?: string | null;
};

let memoryAccessToken: string | null = null;

export function setAccessToken(token: string | null) {
  memoryAccessToken = token;

  try {
    if (token) {
      sessionStorage.setItem(SESSION_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(SESSION_TOKEN_KEY);
    }
  } catch {
    // Ignore storage errors and fall back to memory only.
  }
}

export function clearAccessToken() {
  memoryAccessToken = null;

  try {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
  } catch {
    // Ignore storage errors.
  }
}

export function getAccessToken() {
  if (memoryAccessToken) {
    return memoryAccessToken;
  }

  try {
    const sessionToken = sessionStorage.getItem(SESSION_TOKEN_KEY);
    if (sessionToken) {
      memoryAccessToken = sessionToken;
      return sessionToken;
    }
  } catch {
    // Ignore storage errors and continue to legacy fallback.
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return (JSON.parse(raw) as StoredAuth).token ?? null;
  } catch {
    return null;
  }
}

